import React from 'react'
import moment from 'moment'

import BkFlowNavigationStepButton from '../elements/BkFlowNavigationStepButton'
import BkFlowNavigationDetailsToggle from '../elements/BkFlowNavigationDetailsToggle'
import BkFlowNavigationUtilityBar from '../elements/BkFlowNavigationUtilityBar'
import { onEnter } from '../../../../utilities/accessibility/onEnter'

import yn from 'yn'

if (process.env.REACT_APP_COMPONENT_NAVIGATION === 'grid-steps') {
	require('../../../../styles/css/components/navigation/bk-flow-navigation-steps.css')
}

const BkFlowNavigationGridSteps = props => {
	const {
		configData,
		backButton,
		activeStep,
		activeCurrencyData,
		hotel,
		hotelCode,
		hotelPhone,
		hotelLogo,
		hotelLink,
		arrival,
		departure,
		guests,
		rooms,
		enhancementsTotal,
		exchangeRatesLoading,
		grandTotal,
		updateStep,
		detailsExpanded,
		detailsEvent,
		openEditModal
	} = props
	const hotelLabels = configData.hotel.labels[0],
				componentSteps = []

	let headerClasses = 'bk-flow-header'

	if (
		yn(process.env.REACT_APP_COMPONENT_FIXED_NAVIGATION) &&
		yn(process.env.REACT_APP_COMPONENT_ENABLE_PROFILE_SERVICES)
	) {
		headerClasses = 'bk-flow-header sticky inc-utility'
	} else if (yn(process.env.REACT_APP_COMPONENT_FIXED_NAVIGATION)) {
		headerClasses = 'bk-flow-header sticky'
	} else if (yn(process.env.REACT_APP_COMPONENT_LANGUAGE_UTILITY_BAR)) {
		headerClasses = 'bk-flow-header inc-utility'
	}

	if (
		yn(process.env.REACT_APP_COMPONENT_PRE_ENHANCEMENTS) &&
		yn(process.env.REACT_APP_COMPONENT_POST_ENHANCEMENTS)
	) {
		componentSteps.push(hotelLabels.rooms, hotelLabels.enhancements, hotelLabels.totalBookingCost)
	} else if ( yn(process.env.REACT_APP_COMPONENT_PRE_ENHANCEMENTS) ) {
		componentSteps.push(hotelLabels.rooms, hotelLabels.enhancements, hotelLabels.totalBookingCost)
	} else if ( yn(process.env.REACT_APP_COMPONENT_POST_ENHANCEMENTS) ) {
		componentSteps.push(hotelLabels.rooms, hotelLabels.totalBookingCost, hotelLabels.enhancements)
	} else {
		componentSteps.push(hotelLabels.rooms, hotelLabels.totalBookingCost)
	}

	return (
		<header role="banner">
			<div className={ headerClasses }>
				{ yn(process.env.REACT_APP_COMPONENT_NAVIGATION_UTILITY_BAR) &&
					<BkFlowNavigationUtilityBar
						activeCurrencyData={activeCurrencyData}
						exchangeRatesLoading={exchangeRatesLoading}
					/>
				}

				<div className="bk-flow-mobile-header container-fluid u-text-center">
					<div className="row middle-xs">
						{ backButton(true) }

						<h2 className="u-remove-margin col-xs-8">{ hotelLogo ? hotelLogo : hotel }</h2>						

						<div className="bk-flow-mobile-header__call-btn col-xs-2">
							{ hotelPhone &&
								<a
									className="btn btn-text-only"
									href={ 'tel:' + hotelPhone }
									title="Call Now to Book"
								>
									<i className="material-icons">phone</i>
								</a>
							}
						</div>
					</div>
				</div>
				<div className="bk-flow-leaders-club">
					<a
						href={`https://www.lhw.com/leaders-club-hub?hotel=${hotelCode}`}
						tabIndex={ 0 }
					>
						Leaders Club
					</a>
				</div>
				<nav>			
					<div className="bk-flow-navigation bk-flow-navigation--grid-steps">
						<div className="u-remove-padding">
							<div className="row center-xs">
								<div className="bk-flow-navigation__room-details">

									<div className="u-remove-padding">
										<div className="row">
											{ yn(process.env.REACT_APP_COMPONENT_NAVIGATION_BACK_BUTTON) && backButton(false) }

											{ hotelLogo &&
												<a
													className="bk-flow-navigation__logo u-mobile-hide-tablet-flex"
													href={ hotelLink ? hotelLink : '/' }
													tabIndex={ 0 }
													aria-label="Bardo homepage"
												>
													{ hotelLogo }
												</a>
											}

											<div className="bk-flow-navigation__details col-xs row top-sm middle-xs">
												<div className="bk-flow-navigation__data-col mobile-total column-md start-xs middle-xs">
													{ hotelLabels.total ? hotelLabels.total + ': ' : 'Total: ' }
													{grandTotal}
												</div>

												<div className="bk-flow-navigation__data-col hotel column-md start-xs middle-xs">
													<div className="bk-flow-navigation__data-row col-sm-12 dates">
														<p className="u-remove-margin">{ hotelLabels.dates ? hotelLabels.dates : 'Dates' }:&nbsp;</p>
														<button
																id="bk-toggle-edit-stay"
																className="bk-flow-navigation__edit-stay btn btn-text-only js-toggle__edit-stay"
																onClick={ openEditModal }
															>
																<p className="u-remove-margin u-font-bold">{ moment(arrival.props.children, 'dddd, MMMM D, YYYY').format('MMM D') } - { moment(departure.props.children, 'dddd, MMMM D, YYYY').format('MMM D') }</p>
															</button>
													</div>

													<div className="bk-flow-navigation__data-row col-sm-12 guests">
														<p className="u-remove-margin">{ hotelLabels.guests ? hotelLabels.guests : 'Guests' }:&nbsp;</p>
														{ guests }

														<div className="bk-flow-navigation__edit-stay-container">
															<a
																className="bk-flow-navigation__leaders-club u-mobile-hide-tablet-flex"
																href={`https://www.lhw.com/leaders-club-hub?hotel=${hotelCode}`}
																tabIndex={ 0 }
															>
																Leaders Club
															</a>
															<button
																id="bk-toggle-edit-stay"
																className="bk-flow-navigation__edit-stay btn btn-text-only js-toggle__edit-stay"
																onClick={ openEditModal }
															>
																{ hotelLabels.edit ? hotelLabels.edit : 'Edit' }
															</button>
														</div>
													</div>
												</div>

												<BkFlowNavigationStepButton
													customClasses={ 'rooms' }
													buttonContent={ hotelLabels.rooms ? hotelLabels.rooms : 'Rooms' }
													buttonValue={ rooms }
													activeStep={ activeStep }
													stepValue={ 0 }
													stepEvent={ activeStep > 0 && updateStep }
												/>

												<BkFlowNavigationStepButton
													customClasses={ 'enhancements' }
													buttonContent={ hotelLabels.enhancements ? hotelLabels.enhancements : 'Enhancements' }
													buttonValue={ enhancementsTotal }
													currentStep={ 0 }
													activeStep={ activeStep }
													stepValue={ 1 }
													stepEvent={ activeStep > 1 && updateStep }
												/>

												<div
													className="bk-flow-navigation__edit-stay-mobile btn btn-text-only u-font-bold"
													onClick={ openEditModal }
													onKeyDown={event => onEnter(event, openEditModal)}
													tabIndex={ 0 }
													role="button"
												>
													{ hotelLabels.edit }
												</div>
											</div>
										</div>
									</div>
								</div>

								{ yn(process.env.REACT_APP_COMPONENT_NAVIGATION_TOTAL) &&
									<BkFlowNavigationStepButton
										customClasses={ 'total' }
										buttonContent={ hotelLabels.total ? hotelLabels.total : 'Total'}
										buttonValue={grandTotal}
										currentStep={0}
										activeStep={ activeStep }
										stepValue={ 2 }
										stepEvent={ activeStep >= 2 && updateStep }
									/>
								}

								<BkFlowNavigationDetailsToggle
									hotelLabels={ hotelLabels }
									checked={ detailsExpanded }
									detailsExpanded={detailsExpanded}
									detailsEvent={ detailsEvent }
								/>
							</div>
						</div>
					</div>
				</nav>
			</div>
		</header>
	)
}

export default BkFlowNavigationGridSteps


// WEBPACK FOOTER //
// ./src/components/structure/navigation/layouts/BkFlowNavigationGridSteps.js